// Module
var code = " <isteven-multi-select ng-if=\"!$ctrl.disabled\" input-model=\"$ctrl.mesures\" output-model=\"$ctrl.selectedMesures\" on-close=\"$ctrl.selectMesure()\" group-property=\"msGroup\" search-properties=\"libelle code symbole\" max-labels=\"5\" tick-property=\"selected\" button-label=\"libelle\" item-label=\"libelle\"> </isteven-multi-select> ";
// Exports
module.exports = code;